module.exports = __webpack_public_path__ + "static/media/arts_14.9ead09c2.jpg";